'use client';

import {
  Accordion,
  AccordionContent,
  AccordionHeader,
} from '@jouzen/ecom-components/v3/Accordion';
import { BodyLink } from '@jouzen/ecom-components/v3/BodyLink';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { TypographyRhythm } from '@jouzen/ecom-components/v3/TypographyRhythm';
import { useTranslations } from 'next-intl';

import RichText from '@/app/components/RichText';

const link = (chunks: React.ReactNode) => (
  <BodyLink
    external
    href="https://ouraringhelp.zendesk.com/hc/en-us/requests/new"
    target="_blank"
    rel="noopener noreferrer"
  >
    {chunks}
  </BodyLink>
);

const Content = () => {
  const t = useTranslations();

  return (
    <>
      <Typography variant="h2" Element="h1" align="center" className="mb-24">
        {t('b2b_terms_2_7_term')}
      </Typography>

      <LayoutGrid rowGap={32}>
        <div className="col-main lg:col-end-12">
          <Typography Element="h2" variant="h3">
            {t('checkout_shippinginformation')}
          </Typography>
        </div>
        <div className="col-main lg:col-start-13">
          <Accordion openAtIndex={1} isContentAnimated={false}>
            <AccordionHeader>
              <Typography
                variant="unset"
                Element="h4"
                weight="thin"
                className="max-w-[90%] py-4 text-xl lg:text-3xl"
              >
                {t('shipping_info_faq_question_1')}
              </Typography>
            </AccordionHeader>
            <AccordionContent>
              <div className="pb-4">
                <TypographyRhythm>
                  <Typography>
                    <RichText
                      messageKey="shipping_info_faq_answer_1_1"
                      tValues={{ link }}
                    />
                  </Typography>
                  <Typography>{t('shipping_info_faq_answer_1_2')}</Typography>
                </TypographyRhythm>
              </div>
            </AccordionContent>

            <AccordionHeader>
              <Typography
                variant="unset"
                Element="h4"
                weight="thin"
                className="max-w-[90%] py-4 text-xl lg:text-3xl"
              >
                {t('shipping_info_faq_question_2')}
              </Typography>
            </AccordionHeader>
            <AccordionContent>
              <div className="pb-4">
                <Typography Element="dt" className="mb-4">
                  {t('shipping_info_faq_answer_2_1')}
                </Typography>
                <div className="mb-8 ml-8">
                  <Typography Element="dd">
                    {t('shipping_info_faq_answer_2_2')}
                  </Typography>
                  <Typography Element="dd">
                    {t('shipping_info_faq_answer_2_3')}
                  </Typography>
                  <Typography Element="dd">
                    {t('shipping_info_faq_answer_2_4')}
                  </Typography>
                  <Typography Element="dd">
                    {t('shipping_info_faq_answer_2_5')}
                  </Typography>
                </div>

                <Typography Element="dt" className="mb-4">
                  {t('shipping_info_faq_answer_2_6')}
                </Typography>
                <div className="mb-8 ml-8">
                  <Typography Element="dd">
                    {t('shipping_info_faq_answer_2_7')}
                  </Typography>
                  <Typography Element="dd">
                    {t('shipping_info_faq_answer_2_3')}
                  </Typography>
                  <Typography Element="dd">
                    {t('shipping_info_faq_answer_2_4')}
                  </Typography>
                  <Typography Element="dd">
                    {t('shipping_info_faq_answer_2_5')}
                  </Typography>
                </div>
              </div>
            </AccordionContent>

            <AccordionHeader>
              <Typography
                variant="unset"
                Element="h4"
                weight="thin"
                className="max-w-[90%] py-4 text-xl lg:text-3xl"
              >
                {t('shipping_info_faq_question_3')}
              </Typography>
            </AccordionHeader>
            <AccordionContent>
              <div className="pb-4">
                <TypographyRhythm>
                  <Typography>{t('shipping_info_faq_answer_3_1')}</Typography>
                  <Typography>{t('shipping_info_faq_answer_3_2')}</Typography>
                  <Typography>{t('shipping_info_faq_answer_3_3')}</Typography>
                  <Typography>{t('shipping_info_faq_answer_3_4')}</Typography>
                </TypographyRhythm>
              </div>
            </AccordionContent>

            <AccordionHeader>
              <Typography
                variant="unset"
                Element="h4"
                weight="thin"
                className="max-w-[90%] py-4 text-xl lg:text-3xl"
              >
                {t('shipping_info_faq_question_4')}
              </Typography>
            </AccordionHeader>
            <AccordionContent>
              <div className="pb-4">
                <TypographyRhythm>
                  <Typography>{t('shipping_info_faq_answer_4_1')}</Typography>
                  <Typography>{t('shipping_info_faq_answer_4_2')}</Typography>
                  <Typography>{t('shipping_info_faq_answer_4_3')}</Typography>
                </TypographyRhythm>
              </div>
            </AccordionContent>

            <AccordionHeader>
              <Typography
                variant="unset"
                Element="h4"
                weight="thin"
                className="max-w-[90%] py-4 text-xl lg:text-3xl"
              >
                {t('shipping_info_faq_question_5')}
              </Typography>
            </AccordionHeader>
            <AccordionContent>
              <div className="pb-4">
                <TypographyRhythm>
                  <Typography>{t('shipping_info_faq_answer_5_1')}</Typography>
                  <Typography>{t('shipping_info_faq_answer_5_2')}</Typography>
                </TypographyRhythm>
              </div>
            </AccordionContent>

            <AccordionHeader>
              <Typography
                variant="unset"
                Element="h4"
                weight="thin"
                className="max-w-[90%] py-4 text-xl lg:text-3xl"
              >
                {t('shipping_info_faq_question_6')}
              </Typography>
            </AccordionHeader>
            <AccordionContent>
              <div className="pb-4">
                <TypographyRhythm>
                  <Typography>{t('shipping_info_faq_answer_6_1')}</Typography>
                  <Typography>{t('shipping_info_faq_answer_6_2')}</Typography>
                </TypographyRhythm>
              </div>
            </AccordionContent>

            <AccordionHeader>
              <Typography
                variant="unset"
                Element="h4"
                weight="thin"
                className="max-w-[90%] py-4 text-xl lg:text-3xl"
              >
                {t('terms_and_conditions_canada_header')}
              </Typography>
            </AccordionHeader>
            <AccordionContent>
              <div className="pb-4">
                <TypographyRhythm>
                  <Typography>{t('shipping_info_faq_answer_7_1')}</Typography>
                  <Typography>
                    {t('terms_of_delivery_canada_description')}
                  </Typography>
                </TypographyRhythm>
              </div>
            </AccordionContent>

            <AccordionHeader>
              <Typography
                variant="unset"
                Element="h4"
                weight="thin"
                className="max-w-[90%] py-4 text-xl lg:text-3xl"
              >
                {t('terms_of_delivery_dap_heading')}
              </Typography>
            </AccordionHeader>
            <AccordionContent>
              <div className="pb-4">
                <TypographyRhythm>
                  <Typography>{t('shipping_info_faq_answer_8_1')}</Typography>
                  <Typography>{t('shipping_info_faq_answer_8_2')}</Typography>
                  <Typography>{t('shipping_info_faq_answer_8_3')}</Typography>
                </TypographyRhythm>
              </div>
            </AccordionContent>
          </Accordion>
        </div>
      </LayoutGrid>
    </>
  );
};

export default Content;
